angular.module('stack.common.storage.services.StorageParserService', [])

/**
 * The StorageParserService houses methods leveraged by the storage
 * module that handle parsing operations associated with the pushing
 * and pulling of content in and out of storage implementations
 * (i.e., local and cookie).
 *
 * @class StorageParserService
 * @constructor
 * @module stack.common.storage.services.StorageParserService
 */
.factory('StorageParserService', [
  function () {
    'use strict';

    var service = {
      /**
       * Method examines the the passed value and parses the value
       * when anything except a string is found.
       *
       * @param {string} value - Value to be evaluated
       * @return {string} Stringified value
       */
      stringify: function stringify(value) {
        // Must must not be a string.
        if (!value || typeof value === 'string') {
          return value;
        }

        return JSON.stringify(value);
      },

      /**
       * Method examines the passed value and attempts to parse the value.
       * If an error surfaces, the value passed into the function is returned.
       *
       * @param {string} value - Value to be parsed
       * @return {String | Boolean | Number | Object} parsed value
       */
      parse: function parse(value) {
        // Define.
        var parsed;

        // Must must be valid string.
        if (!value || typeof value !== 'string') {
          return value;
        }

        try {
          parsed = JSON.parse(value);
        } catch (err) {
          parsed = value;
        }

        return parsed;
      }
    };

    return service;
  }
]);
